import {
  createActions
} from 'redux-actions';
import * as Types from '../types';

export const visibilityActions = createActions({}, Types.TOGGLE_NAVIGATION_SIDEBAR);



// WEBPACK FOOTER //
// ./src/store/actions/visibility/index.js